import _extends from "@babel/runtime-corejs3/helpers/extends";
import * as React from 'react';
import classNames from 'classnames';
import Checkbox from '../checkbox';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';

var Card = function Card(props) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _getCompProps = getCompProps('Card', userDefaultProps, props),
      tags = _getCompProps.tags,
      style = _getCompProps.style,
      title = _getCompProps.title,
      avatar = _getCompProps.avatar,
      actions = _getCompProps.actions,
      extra = _getCompProps.extra,
      children = _getCompProps.children,
      className = _getCompProps.className,
      hoverable = _getCompProps.hoverable,
      headStyle = _getCompProps.headStyle,
      bodyStyle = _getCompProps.bodyStyle,
      selectable = _getCompProps.selectable,
      checkboxProps = _getCompProps.checkboxProps,
      customPrefixcls = _getCompProps.prefixCls; // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'card', customPrefixcls);
  var cardClassName = classNames(prefixCls, {
    hoverable: hoverable
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    className: cardClassName,
    style: style
  }, title && !avatar && /*#__PURE__*/React.createElement("header", {
    className: "".concat(prefixCls, "-header"),
    style: headStyle
  }, title), avatar && /*#__PURE__*/React.createElement("header", {
    className: "".concat(prefixCls, "-avatar")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-avatar-img"), {
      circle: !avatar.square
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: avatar.src
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "".concat(prefixCls, "-avatar-title")
  }, avatar.title), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-avatar-desc")
  }, avatar.description))), selectable && /*#__PURE__*/React.createElement(Checkbox, _extends({}, checkboxProps)), tags && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-tags")
  }, tags), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, children), actions && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-actions")
  }, actions), extra && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-extra")
  }, extra));
};

Card.displayName = 'Card';
export default Card;